import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import MfaChallenge from '@/components/MfaChallenge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onLogin }) {
  const hasProcessed = useRef(false);
  const [mfa, setMfa] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const sessionId = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    const clearHash = () => window.history.replaceState(null, '', window.location.pathname);

    if (!sessionId) {
      clearHash();
      window.location.href = '/';
      return;
    }

    axios.post(`${API}/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        clearHash();
        if (res.data.mfa_required) {
          // Google-sign-in Owner/Ops Admin with MFA: no session until the second step passes.
          setMfa({ token: res.data.mfa_token, mode: res.data.mfa_enroll_required ? 'enroll' : 'verify' });
          return;
        }
        onLogin(res.data.user, res.data.token, res.data.is_new_user ? '/onboarding' : '/');
      })
      .catch(() => {
        clearHash();
        window.location.href = '/';
      });
  }, [onLogin]);

  if (mfa) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" data-testid="auth-callback-mfa">
        <Card className="w-full max-w-sm border-2">
          <CardHeader><CardTitle className="text-xl">One more step</CardTitle></CardHeader>
          <CardContent>
            <MfaChallenge mfaToken={mfa.token} mode={mfa.mode} onCancel={() => { window.location.href = '/'; }}
                          onSuccess={(user, token) => onLogin(user, token, '/')} />
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground text-sm">Signing you in with Google...</p>
      </div>
    </div>
  );
}
